import React from 'react'

import { Box, Colors, Icon, MediumIcon, Text } from '@factorialco/deprecated-design-system'

import './index.styles.css'
interface Props extends React.PropsWithChildren {
  icon?: MediumIcon | false
  color?: Colors
  disabled?: boolean
  onClick?: () => void
  children: string
  ariaLabel?: string
}

const SectionButton: React.FC<Props> = ({
  icon,
  color = 'grey800',
  disabled = false,
  onClick,
  children,
  ariaLabel,
}) => {
  return (
    <button
      onClick={onClick}
      className={'SectionButton_button'}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      <Box flexDirection="row" alignItems="center" gap="s2" justifyContent="center" paddingY="s2">
        {icon && <Icon.Medium icon={icon} color={color} />}
        <Text.Normal size="200" weight="semibold" color={color}>
          {children}
        </Text.Normal>
      </Box>
    </button>
  )
}
export default SectionButton
